import "./notFound.css";
import { useNavigate } from "react-router-dom";
export default function NotFound() {
  const navigate = useNavigate();
  return (
    <section className="notfound-section">
      <div className="notfound-container">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Sorry, the page can’t be found</h2>
        <p className="error-description">
          The page you were looking for appears to have been moved, deleted, or
          does not exist.
        </p>
        <button className="home-btn" type="button" onClick={() => navigate("/")}>
          Back to Homepage
        </button>
      </div>

      {/* Background shapes */}
      <div className="bg-shape bg-shape-left"></div>
      <div className="bg-shape bg-shape-right"></div>
    </section>
  );
}
